import fetch from 'isomorphic-fetch';
import queryString from 'query-string';
import { checkHttpStatus, parseJSON } from '../utils';
import {
  MEMBER_PROFILE_REQUEST,
  MEMBER_PROFILE_SUCCESS,
  MEMBER_PROFILE_FAILURE,
  MEMBER_PROFILE_FAVORITES_UPDATE,
} from '../constants';

require('es6-promise').polyfill();

export function memberProfileSuccess(user) {
  return {
    type: MEMBER_PROFILE_SUCCESS,
    payload: {
      user,
    }
  };
}

export function memberProfileFailure() {
  return {
    type: MEMBER_PROFILE_FAILURE,
  };
}

export function memberProfileRequest() {
  return {
    type: MEMBER_PROFILE_REQUEST,
  };
}

export function updateMemberProfileFavorites(items) {
  return {
    type: MEMBER_PROFILE_FAVORITES_UPDATE,
    payload: {
      data: items,
    },
  };
}

export function fetchMemberProfile(username) {
  return dispatch => {
    const timestamp = +new Date();
    dispatch(memberProfileRequest());
    var params = queryString.stringify({ username });
    return fetch(`${SERVER_URL}/get_user_info.json?t=${timestamp}&${params}`)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(response => {
        dispatch(memberProfileSuccess(response.data));
      })
      .catch(error => {
        dispatch(memberProfileFailure());
      });
  };
}
